import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  buttonImageDownload: {
    marginLeft: '242px',
    marginTop: '6px',
    width: '32px',
    height: '32px',
    color: 'white',
    backgroundColor: 'green',
    borderRadius: '5px',
    paddingTop: '3px',
    paddingBottom: '3px',
    '&:hover': {
      backgroundColor: 'green'
    }
  }
}));
